import React from "react";
import styled from "styled-components";
import ServiceSearch from "_c/service-search/index";
import {
  Wrap as SpecsWrap,
  Slide,
  Head,
} from "_c/service-search/Popular/styled";
const StyledServiceSearch = styled(ServiceSearch)`
  ${SpecsWrap} {
    :before {
      content: "";
      background: ${({ bg }) =>
        bg
          ? `url(${bg}) no-repeat fixed center/auto`
          : "var(--grad-primary-n)"};
      z-index: -1;
      pointer-events: none;
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      filter: blur(20px);
      margin: -30px;
      @media (max-width: 1024px) {
        background-attachment: scroll;
      }
    }
    ${({ bg, }) => {
      return bg
        ? ""
        : `
        background: var(--grad-primary-n);
      `;
    }};
    @media (max-width: 575px) {
      ${Slide} {
        color: white;
      }
    }
  }
`;
const Wrap = styled.div`
  width: 100%;
  position: relative;
  height: 380px;
  background: ${({ bg }) =>
    bg ? `url(${bg}) no-repeat fixed center/auto` : "transparent"};
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 10;
  margin-bottom: 30px;
  @media (max-width: 1024px) {
    background-attachment: scroll;
  }
  @media (max-width: 767px) {
    height: auto;
    padding: 30px 0;
  }
  ${Head} {
    @media (max-width: 575px) {
      color: white;
    }
  }
`;
const Search = ({ bg }) => (
  <Wrap bg={bg}>
    <StyledServiceSearch bg={bg} />
  </Wrap>
);

export default Search;
